import React from 'react';
import { Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Layout from '../layout/Layout';

const ProtectedRoute = () => {
  const { user } = useAuth();
  const location = useLocation();
  
  return (
    user ? (
      <Layout>
        <Outlet />
      </Layout>
    ) : (
      <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />
    )
  );
};

export default ProtectedRoute;
